/**
 * 零件库存管理翻译 - 英文
 * Parts Inventory Management - English
 */
import { PartsTranslations } from './zh';

export const partsEn: PartsTranslations = {
  // Module Name
  title: 'Parts Inventory',
  subtitle: 'Parts Inventory Management System',
  
  // Navigation
  overview: 'Overview',
  management: 'Parts Management',
  create: 'Create Part',
  inventoryOps: 'Inventory Operations',
  attributes: 'Attributes',
  labelManagement: 'Label Management',
  warehouseManagement: 'Warehouse Management',
  stationManagement: 'Station Management',
  
  // Overview Page
  totalParts: 'Total Parts',
  lowStock: 'Low Stock',
  outOfStock: 'Out of Stock',
  recentlyAdded: 'Recently Added',
  quickActions: 'Quick Actions',
  createPart: 'Create Part',
  importParts: 'Batch Import',
  exportData: 'Export Data',
  stockAlerts: 'Stock Alerts',
  recentParts: 'Recent Parts',
  refreshData: 'Refresh Data',
  lastUpdated: 'Last Updated',
  
  // Form Sections
  coreInfo: 'Core Information',
  coreInfoDesc: 'Required basic information for all parts',
  groupInfo: 'Group Information',
  groupInfoDesc: 'Fields generated based on selected groups',
  
  // Parts List
  partNumber: 'Part Number',
  partName: 'Part Name',
  partNameEn: 'English Name',
  partNameCn: 'Chinese Name',
  category: 'Category',
  currentStock: 'Current Stock',
  minStock: 'Min Stock',
  maxStock: 'Max Stock',
  unit: 'Unit',
  location: 'Location',
  supplier: 'Supplier',
  price: 'Price',
  stockStatus: 'Stock Status',
  actions: 'Actions',
  source: 'Source',
  specifications: 'Specifications',
  description: 'Description',
  remark: 'Remark',
  station: 'Station',
  warehouseLocation: 'Warehouse Location',
  
  // Label Versions (for table column headers, etc.)
  partNumberLabel: 'Part Number',
  partNameLabel: 'English Name',
  partNameCnLabel: 'Chinese Name',
  specificationsLabel: 'Specifications',
  stationLabel: 'Station',
  warehouseLocationLabel: 'Warehouse Location',
  currentStockLabel: 'Current Stock',
  minStockLabel: 'Min Stock',
  maxStockLabel: 'Max Stock',
  unitLabel: 'Unit',
  statusLabel: 'Status',
  
  // Field Placeholders
  partNumberPlaceholder: 'Enter part number',
  partNamePlaceholder: 'Enter part name',
  partNameEnPlaceholder: 'Enter English name',
  partNameCnPlaceholder: 'Enter Chinese name',
  unitPlaceholder: 'e.g.: pcs, set, meter',
  sourcePlaceholder: 'Supplier or source',
  specificationsPlaceholder: 'Enter specifications',
  descriptionPlaceholder: 'Enter detailed description',
  remarkPlaceholder: 'Enter remarks',
  stationPlaceholder: 'Enter station',
  warehouseLocationPlaceholder: 'Enter warehouse location',
  currentStockPlaceholder: '0',
  minStockPlaceholder: '0',
  maxStockPlaceholder: 'Optional',
  
  // Stock Status
  statusNormal: 'Normal',
  statusLow: 'Low Stock',
  statusOut: 'Out of Stock',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  discontinued: 'Discontinued',
  obsolete: 'Obsolete',
  
  // Filter and Search
  searchPlaceholder: 'Search part number, name...',
  filterByGroup: 'Filter by Group',
  filterByStatus: 'Filter by Status',
  allGroups: 'All Groups',
  allStatus: 'All Status',
  all: 'All',
  enterStation: 'Enter station...',
  enterWarehouse: 'Enter warehouse location...',
  showFilters: 'Show Filters',
  hideFilters: 'Hide Filters',
  clearFilters: 'Clear Filters',
  
  // Part Details
  basicInfo: 'Basic Info',
  stockInfo: 'Stock Info',
  operationHistory: 'Operation History',
  operationType: 'Operation Type',
  quantity: 'Quantity',
  operator: 'Operator',
  operationTime: 'Operation Time',
  operationRemark: 'Remark',
  
  // Operation Types
  opIn: 'Inbound',
  opOut: 'Outbound',
  opAdjust: 'Adjust',
  opTransfer: 'Transfer',
  opReturn: 'Return',
  
  // Create/Edit Part
  createNewPart: 'Create New Part',
  editPart: 'Edit Part',
  partInfo: 'Part Information',
  selectGroup: 'Select Group',
  selectGroups: 'Select Groups',
  pleaseSelectGroup: 'Please select a part group first',
  pleaseSelectGroupPlaceholder: 'Please select groups',
  groupRequired: 'Group is required',
  noGroup: 'No Group',
  selectedGroups: '{count} groups selected',
  fieldsCount: '{count} fields',
  noAvailableGroups: 'No available groups',
  locationPlaceholder: 'e.g., Zone A-01-03',
  supplierPlaceholder: 'Supplier name',
  pricePlaceholder: 'Unit price',
  
  // Batch Import
  importing: 'Import',
  downloadTemplateButton: 'Download Template',
  creating: 'Creating...',
  createPartButton: 'Create Part',
  supportedFormats: 'Supports Excel (.xlsx, .xls) or CSV',
  importSettings: 'Import Settings',
  updateExisting: 'Update existing parts',
  switchToManual: 'Switch to Manual Creation',
  validating: 'Validating...',
  validateData: 'Validate Data',
  startImport: 'Start Import',
  validationSuccess: 'Validation Passed',
  validationFailure: 'Validation Failed',
  row: 'Row',
  rowError: '• Row {row}: {error}',
  moreErrors: '...and {count} more errors',
  importResults: 'Import Results',
  total: 'Total',
  success: 'Success',
  failed: 'Failed',
  updated: 'Updated',
  errorDetails: 'Error Details',
  returnToList: 'Return to List',
  continueImport: 'Continue Import',
  dataPreview: 'Data Preview ({count} rows)',
  moreRows: '...and {count} more rows',
  parsingFile: 'Parsing file...',
  pleaseSelectExcel: 'Please select an Excel file to import',
  importSuggestion: 'Suggest downloading the template first, then import after filling in the data',
  importTemplateFilename: 'Parts_Import_Template_{groupNames}.xlsx',
  
  // Toast Messages
  loadGroupsFailed: 'Failed to load groups',
  partNumberExists: 'Part number "{partNumber}" already exists',
  generateTemplateFailed: 'Failed to generate template',
  parsedRowsSuccess: 'Successfully parsed {count} rows',
  parseExcelFailed: 'Failed to parse Excel file',
  readFileFailed: 'Failed to read file',
  validationPassed: 'Data validation passed',
  foundErrors: 'Found {count} errors',
  validationFailed: 'Validation failed',
  importSuccessCount: 'Successfully imported {count} records',
  importFailed: 'Import failed',
  pleaseEnterRequired: 'Please fill in required fields: Part Number and English Name',
  minStockNegative: 'Min stock cannot be negative',
  currentStockNegative: 'Current stock cannot be negative',
  maxStockLessThanMin: 'Max stock cannot be less than min stock',
  
  // Inventory Operations
  inventoryOperations: 'Inventory Operations',
  inbound: 'Inbound',
  outbound: 'Outbound',
  selectPart: 'Select Part',
  scanPart: 'Scan Part',
  manualInput: 'Manual Input',
  scanInput: 'Scan Input',
  selectInputMethod: 'Select Input Method',
  searchByNumberOrName: 'Search by part number or name',
  scanOrEnterCode: 'Scan or enter part barcode',
  selectOperationType: 'Select Operation Type',
  selectPartFirst: 'Please select a part first',
  partNotFound: 'Part not found',
  operationPreview: 'Operation Preview',
  operationDetails: 'Operation Details',
  afterOperation: 'After Operation',
  scanOperation: 'Scan Operation',
  scanOperationDesc: 'Quick inventory operations using barcode scanner',
  adjustment: 'Adjustment',
  transfer: 'Transfer',
  operationDate: 'Operation Date',
  operationQuantity: 'Quantity',
  targetLocation: 'Target Location',
  reason: 'Reason',
  reasonPlaceholder: 'Please enter operation reason',
  executeOperation: 'Execute Operation',
  operationSuccess: 'Operation successful',
  operationFailed: 'Operation failed',
  
  // Time related
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  
  // Time formatting
  justNow: 'Just now',
  hoursAgo: '{hours} hours ago',
  daysAgo: '{days} days ago',
  
  // Alerts
  alertLevel: 'Alert Level',
  alertType: 'Alert Type',
  alertTime: 'Alert Time',
  alertStatus: 'Alert Status',
  acknowledgeAlert: 'Acknowledge',
  acknowledged: 'Acknowledged',
  unacknowledged: 'Unacknowledged',
  
  // Attributes Management
  partGroups: 'Part Groups',
  coreFields: 'Core Fields',
  customFields: 'Custom Fields',
  groupManagement: 'Group Management',
  fieldManagement: 'Field Management',
  createGroup: 'Create Group',
  editGroup: 'Edit Group',
  deleteGroup: 'Delete Group',
  addField: 'Add Field',
  editField: 'Edit Field',
  deleteField: 'Delete Field',
  
  // Pages and Navigation
  partManagement: 'Part Management',
  inventoryOperation: 'Inventory Operations',
  attributeManagement: 'Attribute Management',
  customFieldManagement: 'Custom Field Management',
  columnManagement: 'Column Configuration',
  
  // Statistics and Status
  activeParts: 'Active Parts',
  lowStockParts: 'Low Stock Parts',
  outOfStockParts: 'Out of Stock Parts',
  recentlyAddedTitle: 'Recently Added',
  stockAlertsTitle: 'Stock Alerts',
  noPermissionToViewStats: 'No permission to view statistics',
  
  // Stock Status
  stock: 'Stock',
  stockInformation: 'Stock Information',
  stockStatusNormal: 'Normal',
  stockStatusLow: 'Low Stock',
  stockStatusOut: 'Out of Stock',
  
  // Action Buttons
  viewParts: 'View Parts',
  viewAllButton: 'View All',
  goToButton: 'Go',
  printLabel: 'Print Label',
  printLabels: 'Print Labels',
  export: 'Export',
  view: 'View',
  confirmDeleteSimple: 'Confirm delete?',
  acknowledgeButton: 'Acknowledge',
  refreshing: 'Refreshing',
  
  // Quick Action Descriptions
  quickCreateDesc: 'Quick create new part',
  quickViewDesc: 'View and manage parts',
  quickInventoryDesc: 'Perform inventory operations',
  
  // Search and Filter
  searchPlaceholderExtended: 'Search part number, name or specs',
  searchGroups: 'Search groups',
  
  // Scan Related
  
  // Field Management
  coreFieldsInfo: 'Core Fields',
  coreFieldsDesc: 'Essential fields required for all parts',
  manageFields: 'Manage Fields',
  createField: 'Create Field',
  fieldName: 'Field Name',
  fieldGroup: 'Field Group',
  associatedGroups: 'Associated Groups',
  activeField: 'Active',
  inactiveField: 'Inactive',
  archivedField: 'Archived',
  activateField: 'Activate Field',
  deactivateField: 'Deactivate Field',
  fieldUpdatedSuccess: 'Field updated successfully',
  fieldDeleteConfirm: 'Are you sure you want to delete this field?',
  fieldDeletedSuccess: 'Field deleted',
  noFieldsInGroup: 'No fields in this group',
  sortable: 'Sortable',
  required: 'Required',
  
  // Group Management
  noGroups: 'No groups yet',
  groupTip1: 'Groups are used to organize part types',
  groupTip2: 'Each group can have custom fields',
  groupTip3: 'Click on a group to view and manage fields',
  
  // Column Configuration
  columnConfig: 'Column Configuration',
  configColumns: 'Configure Columns',
  createConfig: 'Create Configuration',
  configName: 'Configuration Name',
  myConfigs: 'My Configurations',
  publicConfig: 'Public Configuration',
  teamTemplates: 'Team Templates',
  templateConfig: 'Template Configuration',
  setAsDefault: 'Set as Default',
  setDefaultSuccess: 'Set as default successfully',
  configCopiedSuccess: 'Configuration copied',
  configDeleteConfirm: 'Are you sure you want to delete this configuration?',
  configDeletedSuccess: 'Configuration deleted',
  

  // Import Related
  import: 'Import',
  selectFile: 'Select File',
  clickToSelectFile: 'Click to select file',
  templateDownloadSuccess: 'Template downloaded successfully',
  
  // Messages
  loadPartsFailed: 'Failed to load parts',
  createSuccessWithNumber: 'Created successfully, Part Number: {number}',
  createFailed: 'Failed to create',
  noDataMessage: 'No data available',
  noAlertsMessage: 'No alerts',
  
  // Others
  status: 'Status',
  tips: 'Tips',
  noPartsFound: 'No parts found',
  loadingParts: 'Loading...',
  partDeleted: 'Part deleted',
  partSaved: 'Part saved',
  viewDetails: 'View Details',
  
  // Field Types
  fieldTypeText: 'Text',
  fieldTypeNumber: 'Number',
  fieldTypeDecimal: 'Decimal',
  fieldTypeBoolean: 'Yes/No',
  fieldTypeDate: 'Date',
  fieldTypeDatetime: 'Date Time',
  fieldTypeSelect: 'Single Select',
  fieldTypeMultiselect: 'Multi-Select',
  fieldTypeTextarea: 'Text Area',
  fieldTypeUrl: 'URL',
  fieldTypeEmail: 'Email',
  fieldTypePhone: 'Phone',
  fieldTypeFile: 'File',
  fieldTypeImage: 'Image',
  fieldTypeRichText: 'Rich Text',
  fieldTypeJson: 'JSON',
  
  // Field Form
  fieldKey: 'Field Key',
  fieldKeyPlaceholder: 'e.g.: material, color, weight',
  fieldKeyHint: 'Only lowercase letters, numbers, and underscores',
  fieldNameChinese: 'Chinese Name',
  fieldNameChinesePlaceholder: 'e.g.: 材质、颜色、重量',
  fieldNameEnglish: 'English Name',
  fieldNameEnglishPlaceholder: 'e.g.: Material, Color, Weight',
  fieldType: 'Field Type',
  fieldOptions: 'Options',
  fieldDescription: 'Description',
  fieldDescriptionPlaceholder: 'Detailed description of the field',
  fieldPlaceholder: 'Placeholder',
  fieldPlaceholderPlaceholder: 'Placeholder text for the input',
  fieldHelpText: 'Help Text',
  fieldHelpTextPlaceholder: 'Help tip for the field',
  enterOptionValue: 'Enter option value',
  requiredField: 'Required Field',
  visible: 'Visible',
  editable: 'Editable',
  searchable: 'Searchable',
  
  // Group Form
  groupName: 'Group Name',
  groupNamePlaceholder: 'e.g.: Electronics, Mechanical Parts, etc.',
  groupDescriptionPlaceholder: 'Detailed description of the group',
  displayOrder: 'Display Order',
  displayOrderHint: 'Smaller numbers appear first',
  enableGroup: 'Enable Group',
  
  // Detail Page
  partDetails: 'Part Details',
  basicInformation: 'Basic Information',
  identifierInfo: 'Identifier Information',
  recordInfo: 'Record Information',
  qrCode: 'QR Code',
  barcode: 'Barcode',
  supplierPartNumber: 'Supplier Part Number',
  unitPrice: 'Unit Price',
  leadTime: 'Lead Time (Days)',
  noOperationRecords: 'No operation records',
  stockLabel: 'Stock',
  backToList: 'Back to List',

  // Label management
  labels: {
    emptyTitle: 'No parts found',
    emptyDesc: 'Adjust filters and try again',
  },

  // Group selector
  groupSelector: {
    title: 'Select Part Groups',
    description: 'Select one or more groups to generate related fields',
    emptyTitle: 'No groups available',
    emptyDesc: 'Create groups in Attributes first',
    loadFailed: 'Failed to load groups',
    selectedCount: 'Selected {count} groups',
  },
  
  // Error Messages
  pleaseEnterFieldKey: 'Please enter field key',
  pleaseEnterFieldName: 'Please enter field name',
  fieldKeyFormatError: 'Field key can only contain lowercase letters, numbers, and underscores',
  pleaseAddAtLeastOneOption: 'Please add at least one option',
  pleaseEnterGroupName: 'Please enter group name',
  loadPartFailed: 'Failed to load part',
  confirmDeletePart: 'Confirm delete this part? This action cannot be undone.',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Failed to delete',
  updateSuccess: 'Updated successfully',
  updateFailed: 'Failed to update',
  updating: 'Updating...',
  updateButton: 'Update Part',
  exportSuccess: 'Export successful',
  exportFailed: 'Export failed',
  
  // Attributes page specific
  confirmDeleteGroup: 'Are you sure you want to delete group "{name}"?',
  fieldCreatedSuccess: 'Field created successfully',
  createFieldFailed: 'Failed to create field',
  confirmDeleteField: 'Are you sure you want to delete field "{name}"?',
  loadGroupDetailsFailed: 'Failed to load group details',
  loadFailed: 'Failed to load',
  retry: 'Retry',
  partsCount: '{count} parts',
  customFieldsCount: '{count} custom fields',
  addNew: 'Add New',
};
